export class ProjectSummaryModel {
    budget = 0;
    investors = 0;
    checks = 0;
    expenses = 0;
    validations = 0;
    checksQuantity = 0;
    investorQuantity = 0;
    transactionChart = [];
}